import { render, staticRenderFns } from "./RecruitmentKanbanPage.vue?vue&type=template&id=2449b205&scoped=true"
import script from "./RecruitmentKanbanPage.vue?vue&type=script&lang=js"
export * from "./RecruitmentKanbanPage.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentKanbanPage.vue?vue&type=style&index=0&id=2449b205&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2449b205",
  null
  
)

export default component.exports